<template>
  <div>
    <div class="container">
      <div id="logo">
        <img src="../assets/img/wedge-logo.png" width="200px">
      </div>

      <h3>Content Hash Lookup</h3>

      <bootstrap-modal v-for="(verdict, index) in verdicts" title="Analysis Details" :name="'analysisJson' + index">
        <json v-bind:jsonObject="verdict.analysisResult"></json>
      </bootstrap-modal>

      <form @submit.prevent="lookupSubmit" class="form">
        <div class="row">
          <div class="col-xs-12 col-sm-8">
            <div class="input-group input-group-lg">
              <label class="sr-only" for="contentHash">Content Hash</label>
              <input v-model="contentHash" type="text" class="form-control" id="contenthash" placeholder="Content SHA1 Hash" autofocus>
              <div class="input-group-btn">
                <button type="submit" class="btn btn-primary">Lookup</button>
                <button @click.prevent="clearForm" class="btn btn-default">Clear</button>
              </div>
            </div>
          </div>
        </div>
      </form>

      <div class="spacer10"></div>

      <div v-if="displayVerdict">
        <table v-if="verdicts.length > 0" class="table">
          <thead>
            <tr>
              <th>Size</th>
              <th>Date</th>
              <th>Service</th>
              <th>Classification</th>
              <th>Virus Name</th>
              <th>Analysis Result</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(verdict, index) in verdicts">
              <td>{{ verdict.size }}</td>
              <td>{{ formatEpoch(verdict.timestamp) }}</td>
              <td>WedgeMA&trade;</td>
              <td>{{ verdict.classification }}</td>
              <td>{{ verdict.virusName || 'N/A' }}</td>
              <td v-if="'analysisResult' in verdict"><a :href="'#analysisJson' + index" data-toggle="modal">show</a></td>
              <td v-else></td>
            </tr>
          </tbody>
        </table>

        <p v-else>
          No verdicts found for content hash.
        </p>
      </div>

    </div>
  </div>
</template>

<style scoped>
#logo {
  padding-bottom: 1em;
}
.spacer10 { height: 10px; width: 100%; font-size: 0; margin: 0; padding: 0; border: 0; display: block; }
</style>

<script>
import moment from 'moment'
import $ from 'jquery'
import apiSandboxPublic from '../apiSandboxPublic'
import Json from './Json'
import BootstrapModal from './BootstrapModal'
import C from '../constants'

export default {
  components: {
    BootstrapModal,
    Json
  },

  data () {
    return {
      contentHash: '',
      displayVerdict: false,
      verdicts: []
    }
  },

  mounted () {
    // force autofocus to form in the event that the browser doesn't
    this.$nextTick(() => {
      $('[autofocus]:first').focus()
    })
  },

  methods: {
    fetch () {
      if (this.contentHash === '') {
        return
      }

      apiSandboxPublic.fetchVerdict(this.contentHash)
      .then(result => {
        // console.log('got', result)
        this.verdicts = result
        this.displayVerdict = true
      })
      .catch(error => {
        console.log('error fetching verdicts', error)
      })
    },
    lookupSubmit () {
      this.fetch()
    },

    clearForm () {
      this.contentHash = ''
      this.displayVerdict = false
      this.verdicts = []
    },
    formatEpoch (epoch) {
      return moment(epoch, C.M_FMT_MS).format('YYYY-MM-DD')
    }
  }
}
</script>



// WEBPACK FOOTER //
// HashLookup.vue?11396b74